module.exports = __webpack_public_path__ + "media/images/emblems/Iseltwald-coat_of_arms-8c07c50be5305f40436e8d5059310650.svg";